import { SITE } from "./site";

const SITE_ORIGIN = "https://mdcustomconstruction.com";

export const AREAS_SERVED = [
  "Hollywood, MD",
  "Leonardtown, MD",
  "California, MD",
  "Lexington Park, MD",
  "Lusby, MD",
  "Prince Frederick, MD",
  "Waldorf, MD",
  "La Plata, MD",
  "St. Mary's County, MD",
  "Calvert County, MD",
  "Charles County, MD",
];

const baseAddress = {
  "@type": "PostalAddress",
  streetAddress: SITE.address.street,
  addressLocality: SITE.address.city,
  addressRegion: SITE.address.region,
  postalCode: SITE.address.postal,
  addressCountry: "US",
};

const baseGeo = { "@type": "GeoCoordinates", latitude: 38.3372, longitude: -76.5623 };

const openingHours = [
  {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: "08:00",
    closes: "16:30",
  },
];

export const PLATFORM_REVIEWS = [
  { platform: "Google", ratingValue: "4.9", reviewCount: 87, url: "https://www.google.com/search?q=md+custom+construction+hollywood+md" },
  { platform: "Facebook", ratingValue: "5.0", reviewCount: 24, url: "https://www.facebook.com/mdcustomconstruction" },
  { platform: "Yelp", ratingValue: "4.5", reviewCount: 12, url: "https://www.yelp.com/biz/md-custom-construction-hollywood" },
];

const totalReviewCount = PLATFORM_REVIEWS.reduce((n, r) => n + r.reviewCount, 0);
const weightedRating = (
  PLATFORM_REVIEWS.reduce((sum, r) => sum + parseFloat(r.ratingValue) * r.reviewCount, 0) / totalReviewCount
).toFixed(1);

export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  "@id": `${SITE_ORIGIN}/#business`,
  name: SITE.name,
  image: `${SITE_ORIGIN}/logo.webp`,
  logo: `${SITE_ORIGIN}/logo.webp`,
  url: SITE_ORIGIN,
  telephone: SITE.phone,
  email: SITE.email,
  priceRange: "$$",
  address: baseAddress,
  geo: baseGeo,
  openingHoursSpecification: openingHours,
  areaServed: AREAS_SERVED.map((name) => ({ "@type": "City", name })),
  sameAs: [
    "https://www.facebook.com/mdcustomconstruction",
    "https://www.instagram.com/mdcustomconstruction",
  ],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: weightedRating,
    reviewCount: String(totalReviewCount),
    bestRating: "5",
    worstRating: "1",
  },
  review: PLATFORM_REVIEWS.map((r) => ({
    "@type": "Review",
    name: `${r.platform} Reviews of MD Custom Construction`,
    reviewRating: {
      "@type": "Rating",
      ratingValue: r.ratingValue,
      bestRating: "5",
      worstRating: "1",
    },
    author: { "@type": "Organization", name: r.platform, url: r.url },
    publisher: { "@type": "Organization", name: r.platform },
    reviewBody: `Aggregated rating of ${r.ratingValue}/5 from ${r.reviewCount} verified ${r.platform} reviews.`,
  })),
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Home Remodeling Services",
    itemListElement: [
      "Kitchen Remodeling",
      "Bathroom Remodeling",
      "Basement Finishing",
      "Deck Construction",
      "Screen Room Construction",
      "Garage Construction",
      "Roofing",
      "Custom Home Construction",
    ].map((s) => ({
      "@type": "Offer",
      itemOffered: { "@type": "Service", name: s },
    })),
  },
});

export const serviceSchema = (opts: { serviceName: string; serviceType?: string; description: string; url: string }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: opts.serviceName,
  serviceType: opts.serviceType ?? opts.serviceName,
  description: opts.description,
  url: opts.url,
  provider: {
    "@type": "HomeAndConstructionBusiness",
    "@id": `${SITE_ORIGIN}/#business`,
    name: SITE.name,
    telephone: SITE.phone,
    address: baseAddress,
    url: SITE_ORIGIN,
  },
  areaServed: AREAS_SERVED.map((name) => ({ "@type": "City", name })),
  audience: { "@type": "PeopleAudience", geographicArea: { "@type": "AdministrativeArea", name: "Southern Maryland" } },
});
